module.exports = __webpack_public_path__ + "img/蒙版分组7.f9bf81f1.png";